export default "__VITE_ASSET__GIiY6QCx__"